import React, { useState, useEffect } from "react"
import PropTypes from 'prop-types'
import { Link } from "react-router-dom"
import { Dropdown, DropdownToggle, DropdownMenu, Row, Col } from "reactstrap"
import SimpleBar from "simplebar-react"

//Import images
import avatar3 from "../../../assets/images/users/avatar-1.jpg"
import avatar4 from "../../../assets/images/users/avatar-1.jpg"

//i18n
import { withTranslation } from "react-i18next"
import axios from "axios"
import { Config } from "helpers/backend_helper"
import { DASHNOTIFICATIONS } from "helpers/url_helper"

const NotificationDropdown = props => {
  // Declare a new state variable, which we'll call "menu"
  const [menu, setMenu] = useState(false)
  const [notifications, setNotifications] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchData = () =>{
    try {
      const obj = JSON.parse(localStorage.getItem("authWTUser"));
      const data = { userId:obj.id }
      axios.post(DASHNOTIFICATIONS, JSON.stringify(data), Config).then((r)=>{
        setNotifications(r.data)
      }).catch((e)=>{
        console.log(e)
      })
    } catch (error) {
      console.error(error.message);
    }
  }

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <React.Fragment>
      <Dropdown
        isOpen={menu}
        toggle={() => setMenu(!menu)}
        className="dropdown d-inline-block"
        tag="li"
      >
        <DropdownToggle
          className="btn header-item noti-icon "
          tag="button"
          id="page-header-notifications-dropdown"
        >
          <i className="bx bx-bell bx-tada" />
          <span className="badge bg-danger rounded-pill">{notifications.length}</span>
        </DropdownToggle>
        {(notifications.length > 0) && (
        <DropdownMenu className="dropdown-menu dropdown-menu-lg p-0 dropdown-menu-end">
          <div className="p-3">
            <Row className="align-items-center">
              <Col>
                <h6 className="m-0"> {props.t("Notifications")} </h6>
              </Col>
              <div className="col-auto">
                <a href="/Notifications" className="small">
                  View All
                </a>
              </div>
            </Row>
          </div>
     
          
          <SimpleBar style={{ height: "230px" }}>
          {(notifications.length > 0) && notifications.map((item,key) => (
                  <Link to="/Notifications" className="text-reset notification-item" key={key} >
                    <div className="media">
                      <div className="avatar-xs me-3">
                        <span className="avatar-title bg-primary rounded-circle font-size-16">
                          <i className="bx bx-bell" />
                        </span>
                      </div>
                      <div className="media-body">
                        <h6 className="mt-0 mb-1"> {item.ref} </h6>
                        <div className="font-size-12 text-muted">
                          <p className="mb-1">
                            {item.details}
                          </p>
                          <p className="mb-0">
                            <i className="mdi mdi-clock-outline" />{" "}
                            {item.date}
                          </p>
                        </div>
                      </div>
                    </div>
                  </Link>
                  ))} 
          </SimpleBar>
          
          <div className="p-2 border-top d-grid">
            <Link
              className="btn btn-sm btn-link font-size-14 btn-block text-center"
              to="/Notifications"
            >
              <i className="mdi mdi-arrow-right-circle me-1"></i>
              View all
            </Link>
          </div>
        </DropdownMenu>
        )}
      </Dropdown>
    </React.Fragment>
  )
}

export default withTranslation()(NotificationDropdown)

NotificationDropdown.propTypes = {
  t: PropTypes.any
}